/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import { gql, useMutation } from '@apollo/client';

export const USE_CREATE_ORDER_ISSUE = gql`
mutation CreateOrderIssue($images: [ImageUploadInput!]!, $issueType: String!, $description: String!, $dealId: String!, $customerEmail: String!, $details: String!, $lang: String) {
  createOrderIssue(images: $images, issueType: $issueType, description: $description, dealId: $dealId, customerEmail: $customerEmail, details: $details, lang: $lang) {
    dealIssueNumber
    status
  }
}
`;

const toBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const result = reader.result as string;
      const base64 = result.split(",")[1];
      resolve(base64);
    };

    reader.onerror = reject;
  });

export const useCreateOrderIssue = () => {
  const [createOrderIssue] = useMutation(USE_CREATE_ORDER_ISSUE);

  return {
    createIssue: async (issueType, description, dealId, customerEmail, details, images, lang) => {
      const inputs = await Promise.all(
        images.map(async fileState => {
          const base64 = await toBase64(fileState.file);

          return {
            filename: fileState.file.name,
            mimetype: fileState.file.type,
            data: base64
          };
        })
      );
      if (inputs) {
        const res = await createOrderIssue({
          variables: {
            images: inputs,
            issueType,
            description,
            dealId,
            customerEmail,
            details,
            lang
          }
        });
        return res;
      }
    }
  };
};
